import { useMemo } from "react";
import {
  InternalAdminTagCategoryQuery,
  InternalAdminTagCategoryQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_TAG_CATEGORY_QUERY from "../_networking/internal-admin-tag-category";

const useInternalAdminTagCategorys = (id: string | string[] | undefined) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminTagCategoryQuery,
    InternalAdminTagCategoryQueryVariables
  >(INTERNAL_ADMIN_TAG_CATEGORY_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const tagCategories = useMemo(() => {
    if (!data) return [];
    return data.internalAdminTagCategory;
  }, [data]);

  const tagCategory = useMemo(() => {
    if (tagCategories && tagCategories.length === 1) {
      return tagCategories[0];
    }
    return undefined;
  }, [tagCategories]);

  return {
    tagCategory,
    tagCategories,
    loading,
  };
};

export default useInternalAdminTagCategorys;
